import {
    InteractionLayerSizeV2,
    LayerContentOptionsV2,
    LayerManagerV2,
    ShimBackgroundTypeV2,
} from '@volkswagen-onehub/layer-manager'

import React from 'react'
import {Provider} from 'react-redux'
import store from '../../store'
import {RecoverCouponRequestLayer} from '../RecoverCouponRequest'
import {showThanksRecoverPage} from '../../../features/userData/userDataSlice'

function recoverCouponRenderLayer(): React.JSX.Element {
    return (
        <Provider store={store}>
            <RecoverCouponRequestLayer />
        </Provider>
    )
}

let localLayerManager: LayerManagerV2
let layer: {close: () => void}

const RECOVER_COUPON_LAYER_TITLE_ID = 'recover-coupon-layer-title'

export const setRecoverCouponLayerHandle = (layerManager: LayerManagerV2) => {
    localLayerManager = layerManager
}

export const openRecoverCouponLayer = () => {
    if (!localLayerManager) {
        return
    }
    layer = localLayerManager.openInteractionLayer(
        recoverCouponRenderLayer,
        {} as LayerContentOptionsV2,
        {
            'size': InteractionLayerSizeV2.E,
            'aria-labelledby': RECOVER_COUPON_LAYER_TITLE_ID,
            'shimBackgroundType': ShimBackgroundTypeV2.OPAQUE,
            'userCloseable': true,
            'onClose': () => {
                store.dispatch(showThanksRecoverPage(false))
            },
        }
    )
}

export const closeRecoverCouponLayer = () => {
    layer.close()
}
